(function HotelEngineStartBooking($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		var max_commission     = parseFloat($('.commission-slider').attr('max')),
		    due_today_initial  = $('#due_today_initial_amount').val(),
		    total_cost_initial = $('#total_cost_initial_amount').val();

		var max_time      = 600, // max amount of seconds before we say to retry
			current_timer = 0,
			interval;

		Adzuki.onload('HotelEngine/startBooking', function onload() {

			// user adjusted the slider
			$('.commission-slider').change(function _updateSlider() {
				var additional_savings        = getAdditionalSavings().toFixed(2),
				    agent_commission          = getAgentCommission().toFixed(2),
				    $additional_savings_span  = $('.additional-savings'),
				    $adjusted_commission_span = $('.adjusted-commission');

				$additional_savings_span.text(currencyFormat(additional_savings));
				$adjusted_commission_span.text(currencyFormat(agent_commission));

				$('#manual-adjustment').val(additional_savings);

				toggleCommissionButton(true);
			});


			$('.you-pay-later').css('visibility', 'hidden');

			$('input[name="payment_option"]').on('change', function paymentType() {
				let selectedValue = $('input[name="payment_option"]:checked').val();


				if (selectedValue === 'pay_now') {

					$('.payment_info').show();

					$('.billing_info_title').text('Billing Information');

					$('#hotelenginebooking-pay_later').val(0);

					$('.due-today').text($('.you-pay-later .due-later').text().trim());

					$('.you-pay-later').css('visibility', 'hidden');

				} else {

					$('#hotelenginebooking-payment-number').val(null);

					$('.payment_info').hide();

					$('.billing_info_title').text('Customer Information');
					$('.due-today').text('$0.00');

					$('#hotelenginebooking-pay_later').val(1);
					setDueLater();
					$('.you-pay-later').css('visibility', 'visible');
				}

			});


			$('#markup').on("keyup change", function _manuallySetMarkup() {
				toggleCommissionButton(true);
			});

			$("#markup-type").change(function _markupType() {
				var current_markup = getMarkup();

				if (current_markup > 0) {
					toggleCommissionButton(true);
				}
			});

			$("input[name=adjustment_type]:radio").change(function _commissionAdjustment() {
				var $self = $(this),
				    radio = $self.val();

				$('#commission-adjustment-button').removeClass('hidden');
				showCommissionAdjustmentFields(radio);
			});

			interval = setInterval(
				function _updateCurrentTimer() {
					// console.log(current_timer);

					$('#timer-val').html(fancyTimeFormat(parseFloat(max_time - current_timer)));

					if (current_timer >= max_time) {
						clearInterval(interval);

						Adzuki.CustomConfirm({
							title  : 'Decision Time',
							content: 'You have been on this page longer than ' + fancyTimeFormat(max_time) + '. It is recommended to visit this hotel\'s details to re-select the room you would like to purchase. Would you like to view the rooms now?',
							confirm: function confirm() {
								document.location = Adzuki.base_uri + '/HotelEngine/processor/selectHotel/' + $('#giata_id').val();
							}
						});
					}

					current_timer++;
				},
				1000
			);
		});

		$('.remove-adjustment-button').click(function _clearAdjustments(e) {
			var $self = $(this);
			e.preventDefault();
			clearAllAdjustments();

			$self.addClass('disabled');
			$self.attr('disabled', true);

			Adzuki.StatusMessage('info', 'Commission adjustments removed');
		});

		// user wants to save the discount or markup
		$('.adjust-commission-button').click(function _saveAdjustments(e) {
			var additional_savings      = getAdditionalSavings().toFixed(2),
				markup                  = getMarkup(),
				confirm_message         = 'Are you sure that you want to save the adjustments and',
				room_rate               = parseFloat($('#room-rate').val()),
				markup_low_perc         = parseFloat($('#markup').data('low-markup-percentage')),
				markup_high_perc        = parseFloat($('#markup').data('high-markup-percentage')),
				markup_perc             = 0.0,
				markup_type             = getMarkupType(),
				current_adjustment_type = $("input[name=adjustment_type]:checked").val(),
				new_agent_commission    = getAgentNetCommission(),
				markup_override_text    = markupOverrideText();

			e.preventDefault();

			// applying markup
			if (current_adjustment_type === 'markup') {
				if (markup_type === 'percentage') {
					markup_perc = $('#markup').val();
				} else {
					markup_perc = ((markup / room_rate) * 100);
				}

				if (markup_perc > markup_high_perc) {
					Adzuki.StatusMessage('error', 'Sorry, the markup amount you specified is a higher percentage than allowed (' + markup_high_perc + '%). Please re-enter.');
					clearCommissionMarkup();
					toggleMarkupLineItem();
					setAdminFee();
					setDueToday();
					setDueLater();
					setTotalCost();

					return;
				}

				if ((markup_perc >= markup_low_perc) && (markup_perc <= markup_high_perc)) {
					Adzuki.StatusMessage('info', 'The amount of markup you provided is a bit higher than a normal percentage we expect (' + markup_low_perc + '%). This is just a warning, and the amount will be added. Agent commission amount is now ' + currencyFormat(new_agent_commission) + '. ' + markup_override_text);
				}

				if (markup_perc < markup_low_perc) {
					Adzuki.StatusMessage('info', 'Markup applied. Agent commission amount is now ' + currencyFormat(new_agent_commission) + '. ' + markup_override_text);
				}

				$('#hotelenginebooking-payment-markup').val(markup);
				toggleMarkupLineItem();
				setAdminFee();
				setDueToday();
				setDueLater();
				setTotalCost();
				toggleCommissionButton();
			}

			// applying discount
			if (current_adjustment_type === 'discount') {
				confirm_message += ' <b><i>REDUCE</i></b> your commission by giving <b>' + currencyFormat(additional_savings) + '</b> savings to the customer? Agent commission amount will become ' + currencyFormat(new_agent_commission);

				// user has to confirm or decline applying discount
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: confirm_message,
					confirm: function confirm() {

						// store the adjustments in hidden fields to send over to the API
						$('#additional_savings').val(additional_savings);
						$('#adjusted_commission').val($('.commission-slider').val()); // this needs the royalty added back in

						toggleCommissionButton();
						toggleDiscountLineItem();
						setDueToday();
						setDueLater();
						setTotalCost();
					},
					cancel: function cancel() {
						// reset everything
						clearCommissionDiscount();
						toggleDiscountLineItem();

						setDueToday();
						setDueLater();
						setTotalCost();

						toggleCommissionButton();
					}
				});
			}
		});

		// user typed in an amount rather than moved slider
		$('#manual-adjustment').on("change", function _manuallySet() {
			var manual_amount   = parseFloat($(this).val()),
				customer_saving = max_commission - manual_amount;

			if ($(this).val().length === 0) {
				customer_saving = max_commission;
			}

			$('.commission-slider').val(customer_saving);
			$('.commission-slider').trigger("change");
		});

		function clearAllAdjustments()
		{
			clearCommissionDiscount();
			clearCommissionMarkup();
			toggleDiscountLineItem();
			toggleMarkupLineItem();

			setDueToday();
			setDueLater();
			setTotalCost();

			toggleCommissionButton();
		}

		// remove any commission discounts
		function clearCommissionDiscount()
		{
			$('#additional_savings').val(0);
			$('.additional-savings').text('0');
			$('.commission-slider').val(max_commission);
			$('.commission-slider').trigger("change");
		}

		// remove any markup
		function clearCommissionMarkup()
		{
			$('#markup').val('');
			$('#hotelenginebooking-payment-markup').val(0);
		}

		// output in currency format
		function currencyFormat(amt)
		{
			var output = parseFloat(amt).toLocaleString("en-US", {
				style                : "currency",
				currency             : "USD",
				minimumFractionDigits: 2,
			});

			return output;
		}

		// the amount of savings being given to the client
		function getAdditionalSavings()
		{
			return parseFloat(max_commission - $('.commission-slider').val());
		}

		// amount of admin fee, which is a percentage of any markup amount
		function getAdminFee()
		{
			var markup        = getMarkup(),
			    admin_percent = parseFloat($('#markup').data('admin-fee-percentage')),
			    admin_fee     = (markup * (admin_percent / 100));

			return admin_fee;
		}

		// the amount of commission the agent is keeping
		function getAgentCommission()
		{
			return parseFloat($('.commission-slider').val());
		}

		// the agent's commission amt before any discounts or markup
		function getAgentInitialCommission()
		{
			return parseFloat($('#manual-adjustment').attr('max'));
		}

		// the agent's commission amt after any discounts, markup, markup admin fees
		function getAgentNetCommission()
		{
			var initial_commission  = getAgentInitialCommission(),
			    savings             = getAdditionalSavings(),
			    markup              = getMarkup(),
			    admin_fee           = getAdminFee(),
			    adjusted_commission = (initial_commission - savings + markup - admin_fee);

			return adjusted_commission;
		}

		// how much is due today after any discounts or markup?
		function getDueToday()
		{
			var additional_savings = getAdditionalSavings(),
			    markup             = getMarkup();

			// If it's a pay later booking, we need to set the due today amount to 0
			if ($('#hotelenginebooking-pay_later').val() === '1') {
				return 0;
			}
			return (due_today_initial - additional_savings + markup);
		}

		function getDueLater()
		{
			var additional_savings = getAdditionalSavings(),
			    markup             = getMarkup();

			// If it's not a pay later booking, we need to set the due later amount to 0
			if ($('#hotelenginebooking-pay_later').val() === '0') {
				return 0;
			}
			
			return (due_today_initial - additional_savings + markup);
		}

		// amt of markup
		function getMarkup()
		{
			var output    = 0,
			    type      = getMarkupType(),
			    markup    = $('#markup').val(),
			    float     = parseFloat(markup).toFixed(2),
			    room_rate = parseFloat($('#room-rate').val());

			if (markup.length > 0) {
				if (type === 'percentage') {
					output = parseFloat((room_rate) * (float / 100)).toFixed(2);
				} else {
					output = float;
				}
			}

			return parseFloat(output);
		}

		// fixed or percentage?
		function getMarkupType()
		{
			return $("#markup-type").val();
		}

		// what is the total cost after any discounts and markup?
		function getTotalCost()
		{
			var additional_savings = getAdditionalSavings(),
			    markup             = getMarkup();
			return (total_cost_initial - additional_savings + markup);
		}

		function fancyTimeFormat(duration)
		{
			const hrs = ~~(duration / 3600);
			const mins = ~~((duration % 3600) / 60);
			const secs = ~~duration % 60;

			let ret = "";

			if (hrs > 0) {
			  ret += "" + hrs + ":" + (mins < 10 ? "0" : ""); // eslint-disable-line no-implicit-coercion
			}

			ret += "" + mins + ":" + (secs < 10 ? "0" : "");  // eslint-disable-line no-implicit-coercion
			ret += "" + secs; // eslint-disable-line no-implicit-coercion

			return ret;
		}

		function markupOverrideText()
		{
			var admin_fee_percentage = parseFloat($('#markup').data('admin-fee-percentage')),
			    txt                  = 'All markups are subject to a ' + admin_fee_percentage + '% admin fee and that will be subtracted from the total markup amount.';

			return txt;
		}

		function setAdminFee()
		{
			var admin_fee = getAdminFee();

			$('.markup-admin-fee').html(currencyFormat(admin_fee));
		}

		function setDueToday()
		{
			var $due_today    = $('.due-today'),
			    due_today_amt = getDueToday();

			$due_today.text(currencyFormat(due_today_amt));
		}

		function setDueLater()
		{
			var $due_later    = $('.you-pay-later .due-later'),
			    due_later_amt = getDueLater();
		
				$due_later.text(currencyFormat(due_later_amt));
		}

		function setTotalCost()
		{
			var $total_cost    = $('.total-cost'),
			    total_cost_amt = getTotalCost();

			$total_cost.text(currencyFormat(total_cost_amt));

			toggleNetCommission();
		}

		function showCommissionAdjustmentFields(show_type)
		{
			var $discount_el = $('#commission-discount'),
			    $markup_el   = $('#commission-markup');

			if (show_type === 'discount') {
				$discount_el.removeClass('hidden');
				$markup_el.addClass('hidden');
			} else {
				$discount_el.addClass('hidden');
				$markup_el.removeClass('hidden');
			}
		}

		// Enable/disable the button to apply discounts
		function toggleCommissionButton(on = false)
		{
			var $button        = $('.adjust-commission-button'),
			    $remove_button = $('.remove-adjustment-button');

			if (on === true) {
				$button.removeClass('disabled');
				$button.removeAttr('disabled');

				$remove_button.removeClass('disabled');
				$remove_button.removeAttr('disabled');
				return;
			}

			$button.addClass('disabled');
			$button.attr("disabled", true);
		}

		// show/hide discount line item above "Due Today"
		function toggleDiscountLineItem()
		{
			var savings  = getAdditionalSavings(),
			    $display = $('.discount-line-item'),
			    $text    = $('.discount-amount');

			if (savings > 0) {
				$text.text(currencyFormat(savings));
				$display.removeClass('hidden');

				return;
			}

			$text.text('');
			$display.addClass('hidden');
		}

		function toggleMarkupLineItem()
		{
			var markup   = getMarkup(),
			    $display = $('.markup-line-item'),
			    $text    = $('.markup-amount');

			if (markup > 0) {
				$text.text(currencyFormat(markup));
				$display.removeClass('hidden');

				return;
			}

			$text.text('');
			$display.addClass('hidden');
		}

		// want to show the agent's commission amt if discounts or markup applied to make it a bit clearer
		function toggleNetCommission()
		{
			var $el                 = $('#agent-net-commission'),
			    initial_commission  = getAgentInitialCommission(),
			    adjusted_commission = getAgentNetCommission();

			$el.find('.amt').html(currencyFormat(adjusted_commission));

			if (initial_commission === adjusted_commission) {
				$el.addClass('hidden');
			} else {
				$el.removeClass('hidden');
			}
		}
	});
}(jQuery, window.Adzuki || {}));